// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"409":"3e3580b8","642":"619e36c2","658":"ae8b5e7f","728":"85ddb186","810":"39e5da17","982":"484b6af2"}[chunkId] + ".chunk.css";
};